import React, { useEffect } from "react";
import { db } from "./firebase";
import {
  collection,
  addDoc,
  Timestamp,
  doc,
  setDoc,
  deleteDoc,
} from "firebase/firestore";
import logo from "./IMG/logo.png";
import link from "./IMG/link.png"; // Importa o ícone do Link-X
import "./App.css";

function App() {
  // Função para registrar uma visita no Firestore
  const recordLinkXVisit = async () => {
    try {
      await addDoc(collection(db, "linkXPageVisits"), {
        timestamp: Timestamp.now(),
      });
      console.log("Visita do Link-X registrada");
    } catch (error) {
      console.error("Erro ao registrar visita do Link-X:", error);
    }
  };

  // Função para registrar um usuário ativo
  const registerLinkXActiveUser = async () => {
    const userRef = doc(
      collection(db, "linkXActiveUsers"),
      `user_${Date.now()}`
    );
    await setDoc(userRef, {
      lastActive: Timestamp.now(),
    });

    // Atualiza o campo lastActive a cada 5 segundos
    const heartbeatInterval = setInterval(async () => {
      await setDoc(userRef, { lastActive: Timestamp.now() }, { merge: true });
    }, 5000);

    // Remove o documento ao fechar a janela
    window.addEventListener("beforeunload", async () => {
      clearInterval(heartbeatInterval);
      await deleteDoc(userRef); // Remove o documento quando o usuário sair
    });
  };

  // Função para registrar um clique no botão
  const recordLinkXClick = async (buttonName) => {
    try {
      await addDoc(collection(db, "linkXClickMetrics"), {
        button: buttonName,
        timestamp: Timestamp.now(),
      });
      console.log(`Clique registrado para o botão do Link-X: ${buttonName}`);
    } catch (error) {
      console.error("Erro ao registrar clique no Link-X:", error);
    }
  };

  useEffect(() => {
    recordLinkXVisit(); // Registra uma visita quando a página carrega
    registerLinkXActiveUser(); // Registra o usuário como ativo
  }, []);

  return (
    <div className="app">
      <div className="content">
        {/* Logo e nome da loja */}
        <div className="logo-container">
          <img src={logo} alt="Logo" className="logo" />
          <p className="store-name">@Sarantopoulosatelier</p>
        </div>

        {/* Botões de direcionamento */}
       
        <button
          className="button"
          onClick={() => {
            recordLinkXClick("Whatsapp");
            window.open("https://wa.me/5521995051718?text=Ol%C3%A1%2C%20gostaria%20de%20fazer%20um%20or%C3%A7amento%21%21%20%F0%9F%91%9C", "_blank");
          }}
        >
          Whatsapp - Atendimento
        </button>

        <button
          className="button"
          onClick={() => {
            recordLinkXClick("Instagram");
            window.open(
              "https://www.instagram.com/sarantopoulosatelier?igsh=MWozbWp0bzFseXdzdA=="
            );
          }}
        >
          Instagram - Oficial
        </button>
       

      

        {/* Ícone Link-X no final da página */}
        <div className="link-container">
          <img
            src={link}
            alt="Link-X"
            className="link-icon"
            onClick={() => {
              recordLinkXClick("Link-X");
              window.open("https://codexcorp.com.br", "_blank");
            }}
          />
        </div>
      </div>
    </div>
  );
}

export default App;
